import React, { useContext } from 'react';
import { IBLSpinLoader } from '../../IBLSpinLoader';
import externalImg from '../assets/images/external-link.svg';
import { AccountContext } from '../context';

const Footer = ({
                  isSubmitting,
                  handleSubmit,
                }) => {

  const {stripeBillingURL, handleBillingClick} = useContext(AccountContext)

  return (
    <div
      onClick={!isSubmitting ? () => handleSubmit() : () => {
      }}
      className={`w-layout-hflex-account-ui account-submit-btn-container ${stripeBillingURL!=="" ? 'space-between' : ''}`}
    >
      {
        stripeBillingURL!=="" &&
        <div onClick={()=>handleBillingClick()} className="w-layout-hflex-account-ui billing-btn-block hidden-sm">
          <h5 className="billing-btn-header">Billing</h5><img src={externalImg} loading="lazy" alt=""
                                                              className="billing-btn-icon invert" />
        </div>
      }

      <a href="#" className={`default-btn form-submit-btn w-button ${!!isSubmitting ? 'disabled' : ''} `}>
        Save {!!isSubmitting && <IBLSpinLoader color="#FFFFFF" size={16} />}
      </a>
    </div>
  );
};

export default Footer;